module.exports = __webpack_public_path__ + "static/media/banner.1571fc9f.png";